// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentPdfDocumentModel {
    static getAttributeTypeMap() {
        return DocumentPdfDocumentModel.attributeTypeMap;
    }
}
DocumentPdfDocumentModel.discriminator = undefined;
DocumentPdfDocumentModel.attributeTypeMap = [
    {
        "name": "templateData",
        "baseName": "templateData",
        "type": "DocumentPdfFileModel"
    },
    {
        "name": "documentTypeId",
        "baseName": "documentTypeId",
        "type": "number"
    },
    {
        "name": "documentStatus",
        "baseName": "documentStatus",
        "type": "DocumentStatus"
    },
    {
        "name": "documentGroupStatus",
        "baseName": "documentGroupStatus",
        "type": "DocumentGroupStatus"
    },
    {
        "name": "documentGroupSource",
        "baseName": "documentGroupSource",
        "type": "DocumentGroupSource"
    },
    {
        "name": "documentGroupReceivedDate",
        "baseName": "documentGroupReceivedDate",
        "type": "Date"
    },
    {
        "name": "documentOriginalFileName",
        "baseName": "documentOriginalFileName",
        "type": "string"
    },
    {
        "name": "documentPageCount",
        "baseName": "documentPageCount",
        "type": "number"
    },
    {
        "name": "faxAni",
        "baseName": "faxAni",
        "type": "string"
    },
    {
        "name": "faxDns",
        "baseName": "faxDns",
        "type": "string"
    },
    {
        "name": "intakeLayoutId",
        "baseName": "intakeLayoutId",
        "type": "number"
    }
];
//# sourceMappingURL=documentPdfDocumentModel.js.map